export default __webpack_public_path__ + "static/media/GM Syntex Private Limited.8c7a3c75.jpg";